import Cookies from 'js-cookie';
import _ from 'lodash';
import { getSSRCookie } from 'src/lib';

export interface UserSession {
  token: string;
  revokeToken: string;
  userId: number;
  loginId: string;
  method: string;
  mature: number;
  sign: number;
  auth: number;
  type: string;
}

enum Keys {
  UserInfo = 'user',
  CoinInfo = 'coinInfo',
}

export class UserSessionService {
  static storeUserInfo(infos: UserSession) {
    const result = JSON.stringify(infos);
    Cookies.set(Keys.UserInfo, result);
  }

  static getUserInfo(): UserSession | null {
    const objString: string | undefined = Cookies.get(Keys.UserInfo);
    const obj: UserSession = JSON.parse(objString || '{}');
    return _.has(obj, 'token') ? obj : null;
  }

  static getCoinInfo(): any | null {
    const objString: string | undefined = Cookies.get(Keys.CoinInfo);
    const obj: any = JSON.parse(objString || '{}');

    const coinParser = (data: any) => {
      const coin = _.sum(
        _.map(
          _.filter(data, v => v.type < 6),
          'coin',
        ),
      );
      const bonusCoin = _.sum(
        _.map(
          _.filter(data, v => v.type >= 6),
          'coin',
        ),
      );

      return { coin, bonusCoin };
    };

    return _.has(obj, 'coins') ? { ...obj, ...coinParser(obj.coins) } : null;
  }

  static getCookieStore(store: string): UserSession | null {
    const objString: string | undefined = Cookies.get(store);
    const obj: UserSession = JSON.parse(objString || '{}');

    return obj;
  }

  static getUserInfoSSR(context: any): UserSession | null {
    const cookies = getSSRCookie(context, 'user');
    if (cookies) {
      return JSON.parse(cookies);
    } else {
      return null;
    }
  }

  static getUserInfoToken(): string {
    const info = this.getUserInfo();
    if (info === null) return '';

    return info.token;
  }

  static getUserInfoUserId(): string {
    const info = this.getUserInfo();
    if (info == null) return '';

    return info.userId === 0 ? '' : `${info.userId}`;
  }

  static getUserInfoSSRToken(context: any): string {
    const info = this.getUserInfoSSR(context);
    return info ? info.token : '';
  }

  static getUserInfoSSRUserId(context: any): string {
    const info = this.getUserInfoSSR(context);
    if (info == null) return '';

    return info.userId === 0 ? '' : `${info.userId}`;
  }
}
